import script from "./BangKeChiTietNhapPrintModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./BangKeChiTietNhapPrintModal.vue?vue&type=script&lang=ts&setup=true"

import "./BangKeChiTietNhapPrintModal.vue?vue&type=style&index=0&id=6bde41ea&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6bde41ea"]])

export default __exports__